module.exports = __webpack_public_path__ + "img/icon11.e7193c75.c29178ac.svg";